/** @jsx jsx */
import { Fragment, memo, useEffect, useState } from "react";
import Truncate from "react-truncate";
import { jsx } from "theme-ui";
import { Grid, Themed } from "theme-ui";
import { responsive } from "../helpers";
import Stack from "../layout/Stack";

var MovieDetails = function MovieDetails(_a) {
  var callToAction = _a.callToAction,
      certificate = _a.certificate,
      _b = _a.isCentered,
      isCentered = _b === void 0 ? false : _b,
      runtime = _a.runtime,
      release = _a.release,
      synopsis = _a.synopsis,
      title = _a.title,
      truncatedSynopsisLines = _a.truncatedSynopsisLines,
      _c = _a.readMore,
      readMore = _c === void 0 ? false : _c,
      collapseLabel = _a.collapseLabel,
      expandLabel = _a.expandLabel,
      _d = _a.allowTitleBreak,
      allowTitleBreak = _d === void 0 ? true : _d;

  var _e = useState(!truncatedSynopsisLines),
      showFullSynopsis = _e[0],
      setShowFullSynopsis = _e[1];

  useEffect(function () {
    setShowFullSynopsis(!truncatedSynopsisLines);
  }, [truncatedSynopsisLines]);
  var details = [certificate, runtime, release].filter(Boolean).reduce(function (acc, detail, index) {
    acc = acc.concat(index > 0 ? jsx("span", {
      key: index + "-sep"
    }, "\u2022") : null, jsx("span", {
      key: (detail === null || detail === void 0 ? void 0 : detail.toString()) + "-" + index
    }, detail));
    return acc;
  }, []);
  return jsx("div", {
    sx: {
      textAlign: isCentered ? "center" : undefined
    }
  }, jsx(Grid, {
    gap: 2
  }, title && jsx("div", {
    sx: !allowTitleBreak ? {
      width: "100%",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden"
    } : undefined
  }, title), !!details.length && jsx("div", null, jsx(Stack, {
    inline: true
  }, details)), callToAction && jsx("div", {
    sx: {
      paddingY: responsive({
        xs: 2,
        sm: 3
      })
    }
  }, callToAction), synopsis && jsx(Fragment, null, jsx(Themed.p, null, jsx(Truncate, {
    lines: showFullSynopsis ? false : truncatedSynopsisLines,
    ellipsis: jsx("span", null, "...")
  }, synopsis)), readMore && jsx("button", {
    type: "button",
    sx: {
      appearance: "none",
      backgroundColor: "transparent",
      border: "0",
      color: "inherit",
      cursor: "pointer",
      fontSize: "1em",
      margin: "0",
      padding: "0",
      textDecoration: "underline"
    },
    onClick: function onClick() {
      return setShowFullSynopsis(!showFullSynopsis);
    }
  }, showFullSynopsis ? collapseLabel : expandLabel))));
};

export default memo(MovieDetails);